import { Box, Grid } from "@mui/material"
import ClinicApi, { DentistInterface } from "api/master/clinic.api"
import ReportApi, { FindAllReportInterface } from "api/report.api"
import HeaderCard from "component/CardCustom/HeaderCard"
import InputSecondNewRangePicker from "component/Input/InputSecondNewRangePicker"
import { KEY_STORAGE } from "constants/common"
import _ from "lodash"
import moment from 'moment'
import DropdownButton from "new-components/buttons/dropdown-button"
import MainButton from "new-components/buttons/main-button"
import RadioButton from "new-components/buttons/radio-button"
import SelectInput from "new-components/inputs/select-input"
import SelectCheckBoxInput from "new-components/inputs/select_checkbox_input"
import { useCallback, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { getBranch, getSecureItem, setSecureItem } from "utils/app.utils"
import { UseSnCode } from "utils/useSnCode"
import ExportToExcel from "./ExportToExcel"
import RemunerationList from "./RemunerationList"

type Doctors = {
    userId: number
    firstname: string
    lastname: string
    fullname: string
}

export default function Remuneration() {
    const { t } = useTranslation()
    const componentRef = useRef<HTMLDivElement>(null)
    const momentNowRange = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    const momentDate = () => momentNowRange

    const [selectedOptionPrice, setSelectedOptionPrice] = useState<any>(getSecureItem(KEY_STORAGE.REPORT_CONDITION) === 'PAID' ? "PAID" : 'TREATMENT')
    const [branchId, setBranchId] = useState<any>(getBranch())
    const [branches, setBranches] = useState<any[]>([])
    const [checked, setChecked] = useState<boolean>(false)
    const [rowCount, setRowCount] = useState<number>(0)
    const [sortBy, setSortBy] = useState<string>('createAt')
    const [sortType, setSortType] = useState<string>('ASC')

    const [prefix, setPrefix] = useState<string>('ALL')
    const [receiptPrefix, setReceiptPrefix] = useState<any[]>([])
    const [rangeDate, setRangeDate] = useState<string[]>(momentDate)
    const [doctors, setDoctors] = useState<Doctors[]>([])
    const [selectDoctors, setSelectDoctors] = useState<any[]>(['ALL'])
    const [doctorsMultiple, setDoctorsMultiple] = useState<DentistInterface[]>([])
    const [remunerationData, getRemunerationData] = useState<any[]>([])
    const [remunerationPage, setRemunerationPage] = useState<number>(1)
    const [remunerationLimitPage, setRemunerationLimitPage] = useState<number>(10)
    const [remuretionTypePage, setRemurationTypePage] = useState<number>(1)

    const [loading, setLoading] = useState<boolean>(true)
    const [snType, setSnType] = useState(false)

    const handleSnCode = useCallback(() => {
        const fetchData = async () => {
            const sn = await UseSnCode()
            setSnType(sn)
        }

        fetchData()
    }, [snType])

    useEffect(() => {
        handleSnCode()
    }, [])

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const fetchRemuneration = useCallback(() => {
        let condition: FindAllReportInterface = {
            page: remunerationPage,
            pageLimit: remunerationLimitPage,
            branchId: branchId,
            dateStart: rangeDate[0],
            dateEnd: rangeDate[1],
            optionPrice: selectedOptionPrice
        }

        if (doctors) {
            const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
            if (doctor) condition = { ...condition, doctorId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
        }
        if (prefix) condition = { ...condition, prefix: prefix === 'ALL' ? '' : prefix }
        if (sortType) condition = { ...condition, sortType: sortType }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (rangeDate) {
            if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
        }

        ReportApi.reportRemuneration(condition)
            .then(({ headers, data }) => {
                getRemunerationData(data)
                setRowCount(headers['x-total'])
            })
            .catch((e) => setLoading(false))
            .finally(() => setLoading(false))
    }, [remunerationLimitPage, remunerationPage, remuretionTypePage, sortBy, sortType, branchId, prefix, selectDoctors, doctors, rangeDate, selectedOptionPrice])

    const getFindAllBranches = () => {
        ClinicApi.findAllBranches()
            .then(({ data }) => setBranches(data))
            .catch((e) => {
                return
            })
    }

    const getPrefix = () => {
        ClinicApi.allBillPrefix()
            .then(({ data }) => {
                const filteredData = data.map((item: any) => ({ value: item.prefix, name: item.prefix }))
                setReceiptPrefix([...filteredData])
            })
            .catch((e) => {
                return
            })
    }

    const getFiindAllDoctors = () => {
        ClinicApi.findAllDoctors('', '', rangeDate[0], rangeDate[1])
            .then((resp) => {
                setDoctors([{ userId: 999999, fullname: t('REPORT.TITLE.NO_DOCTOR') }, ...resp.data])
                const dentists: DentistInterface[] = resp.data.map((d: any) => {
                    return {
                        dentistId: d.userId,
                        dentistFullname: d.fullname
                    }
                })
                setDoctorsMultiple([{ dentistId: 0, dentistFullname: t('REPORT.TITLE.NO_DOCTOR') }, ...dentists])
                setSelectDoctors(['ALL', ...dentists.map((d: DentistInterface) => d.dentistId)])
            })
            .catch((e) => {
                return
            })
    }
    useEffect(() => {
        getFindAllBranches()
        getPrefix()
        getFiindAllDoctors()
    }, [branchId])

    useEffect(() => {
        fetchRemuneration()
    }, [])

    useEffect(() => {
        if (rangeDate[1] !== 'Invalid date' && rangeDate[1]) {
            ClinicApi.findAllDoctors('', '', rangeDate[0], rangeDate[1])
                .then((resp) => {
                    setDoctors([{ userId: 999999, fullname: t('REPORT.TITLE.NO_DOCTOR') }, ...resp.data])
                    const dentists: DentistInterface[] = resp.data.map((d: any) => {
                        return {
                            dentistId: d.userId,
                            dentistFullname: d.fullname
                        }
                    })
                    setDoctorsMultiple([{ dentistId: 0, dentistFullname: t('REPORT.TITLE.NO_DOCTOR') }, ...dentists])
                    setSelectDoctors([...dentists.map((d: DentistInterface) => d.dentistId)])
                })
                .catch((e) => {
                    return
                })
        }
    }, [rangeDate[1]])

    const handleDoctorChange = (selected: any[]) => {
        const selectableIds = doctors.map((o: any) => o.id)
        const allSelected = selectableIds.every((id: any) => selectDoctors.includes(id))
        if (selected.includes(null)) {
            if (allSelected) {
                setSelectDoctors([])
            } else {
                setSelectDoctors(selectableIds)
            }
        } else {
            setSelectDoctors(selected as number[])
        }
    }

    const setDoc = (data: any) => {
        const sortedSelectData = data.sort((a: any, b: any) => {
            const idA = a.dentistId
            const idB = b.dentistId
            return selectDoctors.indexOf(idA) - selectDoctors.indexOf(idB)
        })
        return sortedSelectData
    }
    const filter = [
        branchId === 0 ? `${t(`REPORT.FILTER.ALL`)}` : `${_.get(_.find(branches, { branchId: branchId }), 'branchName' || 'branchNameEn')}`,
        rangeDate[0],
        rangeDate[1],
        prefix === 'ALL' ? `${t(`REPORT.FILTER.ALL`)}` : prefix,
        _.isEmpty(selectDoctors)
            ? ` ${t('REPORT.FILTER.NO_SELECT')}`
            : selectDoctors.filter((i) => typeof i === 'number').length === doctors.length
                ? `${t('REPORT.FILTER.ALL')}`
                : `${setDoc(doctors.filter((d: any) => selectDoctors.includes(d.userId)))
                    ?.map((d: any) => d.fullname)
                    .slice(0, 3) // เเสดงเเค่ 3 คนเเรก
                    .join(', ')}`
    ]

    const exportExcel = async () => {
        setLoading(true);
        try {
            await ExportToExcel({
                data: remunerationData,
                doctors: doctorsMultiple,
                branches,
                branchId,
                filter,
                filterDateStart: rangeDate[0],
                filterDateEnd: rangeDate[1],
                snType: snType,
                t,
            })
        } catch (error) {
            console.error('Error exporting to Excel:', error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Box>
            <HeaderCard text={t(`REPORT.REPORT_NAME.REMUNERATION`)} />
            <Box padding="16px">
                <RadioButton
                    name="radio-buttons-group"
                    onChange={(e) => {
                        setSecureItem(KEY_STORAGE.REPORT_CONDITION, e.target.value.toString())
                        setSelectedOptionPrice(e.target.value)
                    }}
                    row={true}
                    sx={{ gap: '8px' }}
                    value={selectedOptionPrice}
                    options={[
                        { label: t('REPORT.FILTER.PRICE_OF_TREATMENT'), value: 'TREATMENT', },
                        { label: t('REPORT.FILTER.ACTUAL_PRICE_PAID'), value: 'PAID', }]}
                />
                <Grid container spacing="16px">
                    <Grid item xs={12} sm={6} md={4} xl={2}>
                        <SelectInput
                            onChange={(e) => {
                                setBranchId(e.target.value)
                                setRemunerationPage(1)
                            }}
                            options={_.map(branches, (item) => ({ value: item.branchId, name: item.branchName || item.branchNameEn }))}
                            value={branchId}
                            defaultValue={`${_.get(_.find(branches, { branchId: branchId }), 'branchName' || 'branchNameEn')} `}
                            label={t('REPORT.FILTER.BRANCH')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} xl={2}>
                        <InputSecondNewRangePicker
                            inputHeight={40}
                            value={rangeDate || ['', '']}
                            onchange={(val: any) => {
                                if (_.isEmpty(val)) setRangeDate(['', ''])
                                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                                setRemunerationPage(1)
                                setRemunerationLimitPage(1)
                            }}
                            label={`${t('REPORT.TABLE.DECREASE.DATE_START')} » ${t('REPORT.TABLE.DECREASE.DATE_END')}`}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} xl={2}>
                        <SelectInput
                            onChange={(e) => {
                                setPrefix(e.target.value)
                                setRemunerationPage(1)
                                setRemurationTypePage(1)
                            }}
                            options={[{ value: 'ALL', name: t('REPORT.FILTER.ALL') }, ...receiptPrefix]}
                            value={prefix}
                            label={t('REPORT.FILTER.RECEIPT_TYPE')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} xl={2} onClick={() => {
                        // setChecked(!checked)
                        // setRemunerationPage(1)
                    }}>
                        <SelectCheckBoxInput
                            label={t('REPORT.FILTER.DOCTOR')}
                            options={doctors.map((d) => ({
                                id: d.userId,
                                name: d.fullname
                            }))}
                            selected={selectDoctors}
                            onChange={handleDoctorChange}
                            fullWidth
                            helperText={''}
                            loading={false}
                            disabled={false}
                            searchable
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={8} xl={4}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <MainButton
                                title={t('INPUT.SEARCH')}
                                onClick={() => {
                                    setRemunerationPage(1)
                                    getRemunerationData([])
                                    fetchRemuneration()
                                }}
                                type={'primary'}
                                variant={'contained'}
                            />
                            <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                                if (e === 'Excel') exportExcel()
                                if (e === 'PDF') {
                                    const style = document.createElement("style");
                                    style.innerHTML = `
                                          @media print {
                                            @page { size: landscape }
                                            }
                                        `;
                                    document.head.appendChild(style);
                                    window.print();
                                    document.head.removeChild(style);
                                }
                            }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box padding="16px">
                <RemunerationList
                    filter={filter}
                    page={remunerationPage}
                    pageLimit={remunerationLimitPage}
                    rowCount={rowCount}
                    sortBy={sortBy}
                    sortType={sortType}
                    data={remunerationData}
                    doctors={doctorsMultiple}
                    onRequestSort={onRequestSort}
                    handleChangeRowsPerPage={(limit: number) => setRemunerationLimitPage(limit)}
                    handleChangePage={(val: number) => setRemunerationPage(val)}
                    filterDateStart={rangeDate[0]}
                    filterDateEnd={rangeDate[1]}
                    componentRef={componentRef}
                />
            </Box>
        </Box>
    )
}